// extracted by mini-css-extract-plugin
module.exports = {"Dropdown":"appointments__CreateForm__Dropdown","buttonRow":"appointments__CreateForm__buttonRow","labelNotes":"appointments__CreateForm__labelNotes"};